import type { OnyxPhone } from '../interfaces';

export class PhoneHelper {
  public static composeLabel(phone: OnyxPhone): string {
    return `${phone.areaCode} ${phone.number}`;
  }

  public static sanitizePhoneNumber(phoneNumber: string): string {
    return phoneNumber.replace(/[()\s]/g, '');
  }
}
